module.exports = __webpack_public_path__ + "img/linkedin-logo.9c2fb9e5.svg";